import { transient, autoinject, bindable } from "aurelia-framework";

import "amcharts3";
import "amcharts3/amcharts/pie.js";
import "amcharts3/amcharts/serial.js";
import "amcharts3/amcharts/gauge.js";
import "amcharts3/amcharts/plugins/animate/animate.min.js";
import "amcharts3/amcharts/plugins/dataloader/dataloader.min.js";
import "amcharts3/amcharts/plugins/responsive/responsive.min.js";

import { Guid } from "../../../utilities/guid";
import { ChartBaseTypes } from "./chart";
const amcharts3 = window["AmCharts"];

@autoinject
@transient()
export class Gauge {
    private id = Guid.generateGuid();

    @bindable
    value: number = 0;

    @bindable
    exportEnabled: boolean;

    @bindable
    exportDivId: string;

    @bindable
    responsive: boolean;

    chart: any;
    isAttached: boolean;

    isRendered: boolean = false;

    attached() {
        this.chart = this.init();
        this.isAttached = true;
        this.setValue(this.value);
    }

    afterRendered(e){
        if(!this.isRendered){
            this.isRendered = true;
            e.chart.validateNow();
        } 
    }

    valueChanged() {
        this.setValue(this.value);
    }

    setValue(value) {
        if (value >= 0 && this.isAttached && this.chart && this.chart.arrows[0].setValue) {
            //because the value returned is always percentage we have to check whether the 
            //value exceeds a 100 if so limit the gauge to 100 but still show the percentage
            const maxTargetValue = value > 100 ? 100: value;
            this.chart.arrows[0].setValue(maxTargetValue);
            this.chart.axes[0].setTopText(Math.round(value) + " %");
            // adjust darker band to new value
            this.chart.axes[0].bands[1].setEndValue(maxTargetValue);
        }
    }

    init() {
        if (this.chart) {
            if (this.chart.AmExport && this.chart.AmExport.setup.menu.parentNode) {
                this.chart.AmExport.setup.menu.parentNode.removeChild(this.chart.AmExport.setup.menu);
                this.chart.AmExport.clear();
            }
            this.chart.clear();
        }

        const options: any = {

            hideCredits:true,
            path: "views/components/chart/amcharts",
            type: ChartBaseTypes.Gauge,
            marginBottom:-20,
            marginLeft:0,
            marginTop:10,
            marginRight:0,
            axes: [{
                topTextFontSize: 20,
                topTextYOffset: 110,
                axisColor: "#4a4a4a",
                axisThickness: 2,
                endValue: 100,
                gridInside: true,
                inside: false,
                radius: "100%",
                valueInterval: 10,
                tickColor: "#4a4a4a",
                startAngle: -90,
                endAngle: 90,
                unit: "%",
                bandOutlineAlpha: 0,
                bands: [{
                    color: "#f9f9f9",
                    endValue: 100,
                    innerRadius: "50%",
                    radius: "100%",
                    startValue: 0
                }, {
                    color: "#65BAF9",
                    endValue: 0,
                    innerRadius: "50%",
                    radius: "100%",
                    startValue: 0
                }]
            }],
            arrows: [{
                alpha: 1,
                innerRadius: "20%",
                nailRadius: 0,
                radius: "100%"
            }],
            responsive: {
                enabled: this.responsive
            },
            export: {
                enabled: this.exportEnabled,
                divId: this.exportDivId,

                libs: {
                    autoLoad:false,
                }
            }

        };

        const chart = amcharts3.makeChart(`chartdiv-${this.id}`, options);

        chart.addListener("rendered", (e)=> { 
            this.afterRendered(e);           
        });

        chart.validateNow();

        return chart;
    }
}
